import { Component, inject } from '@angular/core';
import { UserStore } from '../../../stores/user.store';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent {
  public userStore = inject(UserStore);

  public get avatarText(): string {
    return (
      this.userStore.user()!.firstname[0].toUpperCase() +
      this.userStore.user()!.lastname[0].toUpperCase()
    );
  }
}
